<template>
  <a-layout style="flex: 1 0 auto;">
    <!-- ========== 桌面端：经典侧边栏布局 ========== -->
    <template v-if="!isMobile && !fullScreen">
      <a-layout-sider v-model="collapsed" :trigger="null" collapsible width="208" class="main-aside">
        <div class="logo">
          <img src="~@/assets/image/logo.png">
          <span v-show="!collapsed">培训视频平台</span>
        </div>
        <a-menu
          mode="inline"
          theme="dark"
          class="aside-menu"
          :inline-collapsed="collapsed"
          :selected-keys="selectedKeys"
          :style="{ borderRight: 0, height: 'calc(100vh - 91px)', overflow: 'auto' }" >
          <template v-for="item in asideMenuTree">
            <sub-menu v-if="item.children && item.children.length" :key="item.menuid" :menu-info="item" @click-menu-item="clickMenuItem"></sub-menu>
            <a-menu-item v-else :key="item.menuid" @click="clickMenuItem(item)">
              <a-icon v-if="item.menupic" :type="item.menupic" />
              <span>{{item.menuname}}</span>
            </a-menu-item>
          </template>
        </a-menu>
        <div class="trigger-bottom" :class="collapsed?'trigger-collapsed':''">
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="() => ($store.commit('main/setCollapsed', !collapsed))"
          />
        </div>
      </a-layout-sider>
    </template>

    <a-layout style="overflow: hidden;position: relative;">
      <!-- ========== 桌面端顶部栏 ========== -->
      <a-layout-header class="header" v-if="!isMobile && !fullScreen">
        <div class="tab-group">
          <page-tabs size="large" :active-key="selectedTab" @change="tabChange" @edit="tabEdit">
            <a-tab-pane v-for="(item, index) in tabs" :key="item.id" :tab="item.name" :closable="index>0"></a-tab-pane>
          </page-tabs>
        </div>
        <div class="header-right">
          <a-dropdown>
            <div class="user-avatar">
              <a-avatar icon="user" />
              <span style="display: inline-block; margin-left: 10px;">{{$store.state.userInfo.username}}</span>
            </div>
            <a-menu slot="overlay" @click="avatarClick">
              <a-menu-item key="user">个人中心</a-menu-item>
              <a-menu-item key="logout">退出登录</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-layout-header>

      <!-- ========== 移动端顶部导航栏 ========== -->
      <div class="mobile-header" v-if="isMobile && mobileHeaderVisible">
        <a-icon type="menu" class="mobile-menu-btn" @click="mobileDrawerOpen = true" />
        <span class="mobile-title">培训视频平台</span>
        <div class="mobile-header-right">
          <a-dropdown>
            <a-icon type="user" class="mobile-user-btn" />
            <a-menu slot="overlay" @click="avatarClick">
              <a-menu-item key="user">个人中心</a-menu-item>
              <a-menu-item key="logout">退出登录</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>

      <!-- ========== 移动端抽屉菜单 ========== -->
      <a-drawer
        placement="left"
        :visible="mobileDrawerOpen"
        :width="drawerWidth"
        :body-style="{ padding: 0, background: '#001529' }"
        :closable="false"
        @close="mobileDrawerOpen = false"
        wrap-class-name="mobile-drawer"
      >
        <div class="drawer-logo">
          <img src="~@/assets/image/logo.png" class="drawer-logo-img">
          <span>培训视频平台</span>
        </div>
        <a-menu
          mode="inline"
          theme="dark"
          :selected-keys="selectedKeys"
          :openKeys="mobileOpenKeys"
          :style="{ borderRight: 0 }"
          @click="onMobileMenuClick"
          @openChange="onMobileOpenChange"
        >
          <template v-for="item in asideMenuTree">
            <sub-menu v-if="item.children && item.children.length" :key="item.menuid" :menu-info="item" @click-menu-item="onMobileMenuClick"></sub-menu>
            <a-menu-item v-else :key="item.menuid">
              <a-icon v-if="item.menupic" :type="item.menupic" />
              <span>{{item.menuname}}</span>
            </a-menu-item>
          </template>
        </a-menu>
      </a-drawer>

      <!-- ========== 内容区域 ========== -->
      <a-layout-content
        :style="contentStyle"
        @scroll="pageScroll"
      >
        <transition name="page-move">
          <keep-alive :include="$store.state.keepAliveComponents">
            <router-view />
          </keep-alive>
        </transition>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { logout } from 'A/login'
import PageTabs from 'C/PageTabs'
import { Menu } from 'ant-design-vue';
import {getCache, removeCache} from 'U'
const SubMenu = {
  template: `
      <a-sub-menu :key="menuInfo.menuid" v-bind="$props" v-on="$listeners">
        <span slot="title">
          <a-icon v-if="menuInfo.menupic" :type="menuInfo.menupic" />
          <span>{{ menuInfo.menuname }}</span>
        </span>
        <template v-for="item in menuInfo.children">
          <sub-menu v-if="item.children && item.children.length" :key="item.menuid" :menu-info="item" @click-menu-item="clickMenuItem" />
          <a-menu-item v-else :key="item.menuid" @click="clickMenuItem(item)">
            <a-icon v-if="item.menupic" :type="item.menupic" />
            <span>{{ item.menuname }}</span>
          </a-menu-item>
        </template>
      </a-sub-menu>
    `,
  name: 'SubMenu',
  // must add isSubMenu: true
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    // Cannot overlap with properties within Menu.SubMenu.props
    menuInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    clickMenuItem(item) {
      this.$emit('click-menu-item', item);
    },
  }
};
export default {
  data() {
    return {
      isMobile: false,
      mobileDrawerOpen: false,
      mobileOpenKeys: [],
    };
  },
  components: {
    SubMenu,
    PageTabs
  },
  computed: {
    ...mapState({
      collapsed: state => state.main.collapsed,
      selectedKeys: state => state.main.selectedKeys,
      tabs: state => state.main.tabs,
      selectedTab: state => state.main.selectedTab,
      fullScreen: state => state.main.fullScreen,
    }),
    ...mapGetters(['asideMenuTree']),
    contentStyle() {
      const base = { position: 'relative', minHeight: '280px', height: '100vh', flexShrink: '0', flexGrow: '0', overflow: 'auto' }
      if (this.fullScreen) return { ...base, padding: '0' }
      if (this.isMobile) return { ...base, padding: '46px 0 0 0' }
      return { ...base, padding: '50px 0 0 0' }
    },
    mobileHeaderVisible() {
      return !this.fullScreen
    },
    drawerWidth() {
      return Math.min(window.innerWidth * 0.75, 280)
    },
  },
  watch: {
    mobileDrawerOpen(val) {
      if(val) {
        this.mobileOpenKeys = this.getParentMenuKeys(this.asideMenuTree);
      }
    },
    asideMenuTree: {
      handler(val) {
        if(this.mobileDrawerOpen && val && val.length) {
          this.mobileOpenKeys = this.getParentMenuKeys(val);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.detectMobile()
    if(this.isMobile) {
      this.mobileDrawerOpen = true
    }
    window.addEventListener('resize', this.detectMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.detectMobile)
  },
  methods: {
    detectMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    onMobileMenuClick(item) {
      this.mobileDrawerOpen = false
      this.clickMenuItem(item)
    },
    onMobileOpenChange(keys) {
      this.mobileOpenKeys = keys
    },
    getParentMenuKeys(tree) {
      let keys = []
      tree.forEach(item => {
        if(item.children && item.children.length) {
          keys.push(item.menuid)
          keys = keys.concat(this.getParentMenuKeys(item.children))
        }
      })
      return keys
    },
    setMenuActived() {
      this.$store.commit('main/setSelectedKeys', [this.$route.name]);
    },
    clickMenuItem(menuItem) {
      if(menuItem.menuurl) {
        // 支持 menuurl 携带 query 参数，格式：routeName?key1=val1&key2=val2
        let [path, queryString] = menuItem.menuurl.split('?');
        let routeConfig = {name: path};
        if(queryString) {
          let query = {};
          queryString.split('&').forEach(pair => {
            let [key, value] = pair.split('=');
            if(key) {
              query[key] = decodeURIComponent(value || '');
            }
          });
          routeConfig.query = query;
        }
        this.$router.push(routeConfig);
      }
    },
    tabChange(key) {
      this.$router.push({name: key})
    },
    tabEdit(key, action) {
      if(action == 'remove') {
        // console.log(this.$route.name)
        if(key == 'elevatorArchives' && this.$route.name == 'timeMonitoring') {
          this.$router.push({name: 'home'})
        }
        if((key == 'enquipmentList' || key == 'equipmentGroup') && this.$route.name == 'paramsConfig') {
          this.$router.push({name: 'home'})
        }
        if(this.selectedTab == key) {
          this.$router.push({name: 'home'})
        }
        this.$store.commit('main/delTab', key)
      }
    },
    avatarClick({key}) {
      if(key == 'logout') {
        logout().then(res => {
          // if(res && res.returncode == '0') {
            removeCache('logininfo', true);
            this.$store.commit('main/resetTabs');
            this.$store.commit('setToken');
            this.$router.push({
              name:'login',
              params:{
                flag:true
              }
            })
          // }else {
          //   this.$message.error(res.errormsg||'操作失败');
          // }
        }).catch(err => {
          removeCache('logininfo', true);
          this.$store.commit('main/resetTabs');
          this.$store.commit('setToken');
          this.$router.push({
            name:'login',
            params:{
              flag:true
            }
          })
        })
      }else if(key == 'user') {
        this.$router.push({name: 'userCenter'})
      }
    },
    pageScroll(event) {
      // console.log(event)
      let ele = event.target || event.srcElement;
      // console.log(ele.scrollTop, ele.scrollLeft)
      this.$store.commit('setPageScrollInfo', {top: ele.scrollTop, left: ele.scrollLeft});
    },
  }
};
</script>
<style lang="scss" scoped>
.main-aside {
  position: relative;
  z-index: 2;
  box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.35);
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  img {
    height: 30px;
  }
  span {
    display: inline-block;
    margin-left: 8px;
    font-size: 12px;
    color: white;
    white-space: nowrap;
  }
}
.header {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 2;
  display: flex;
  height: 50px;
  background: #fff;
  padding: 0;
  box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
}
.trigger {
  font-size: 18px;
  line-height: 40px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
  flex-shrink: 0;
}
.trigger:hover {
  color: #1890ff;
}
.tab-group {
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
}
.header-right {
  flex-shrink: 0;
  line-height: 50px;
  padding: 0 26px;
}
.trigger-bottom {
  position: fixed;
  z-index: 20;
  bottom: 0;
  left: 0;
  overflow: hidden;
  width: 208px;
  height: 41px;
  color: white;
  border-top: solid 1px #131b24;
  background-color: #001529;
  transition: width ease 0.2s;
}
.trigger-collapsed {
  width: 80px;
}
.page-move-enter-active, .page-move-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform .3s;
}
.page-move-enter {
  transform: translateX(-100%)
}
.page-move-leave-to {
  transform: translateX(100%)
}

// ========== 移动端顶部导航栏 ==========
.mobile-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 46px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  background: #001529;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.mobile-menu-btn {
  font-size: 20px;
  color: #fff;
  padding: 6px;
  cursor: pointer;
  flex-shrink: 0;
}

.mobile-title {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-left: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-header-right {
  flex-shrink: 0;
  margin-left: auto;
}

.mobile-user-btn {
  font-size: 20px;
  color: #fff;
  padding: 6px;
  cursor: pointer;
}

// ========== 移动端抽屉菜单 ==========
.drawer-logo {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  .drawer-logo-img {
    height: 32px;
    margin-right: 12px;
  }

  span {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
  }
}
</style>
